import api from 'api'
import {
  CACHE_TAG_ROUTES,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_ROUTES_GEOJSON,
  CACHE_TAG_ROUTES_TIMESTAMPS,
  CACHE_TAG_ROUTE_STOP_LISTS,
} from 'api/cacheTagTypes'
import { get } from 'utils/lodash'
import { transformResponse } from 'utils/route'

export const getRouteTimestampsQuery = ({ routes, serviceDate }) => ({
  url: '/api/v1/core/route/stops/location-timestamps',
  method: 'POST',
  body: { routes, serviceDate },
})

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getRouteStops: build.query({
      query: ({ routes, serviceDate }) => ({
        url: '/api/v1/core/route/stops/get',
        method: 'POST',
        body: { routes, serviceDate },
      }),
      transformResponse: data => {
        // Build an id→route index in the same pass that rebuilds the payload, so
        // Board V2 columns and the search coordinator read their route's stops in
        // O(1) instead of scanning the routes array (N columns × find = O(N²) at
        // ~65 routes). `routes` is left untouched for the legacy/map consumers.
        const routesById = {}
        const newRoutes = get(data, 'routes', []).map(route => {
          const transformed = { ...route, stops: transformResponse(get(route, 'stops', [])) }
          routesById[transformed.id] = transformed
          return transformed
        })
        return { ...data, routes: newRoutes, routesById }
      },
      providesTags: (result, error, body) =>
        body?.skipCache ? [] : [CACHE_TAG_ROUTES, CACHE_TAG_ROUTES_STOPS, CACHE_TAG_ROUTE_STOP_LISTS],
    }),
    getRouteStopsGeojson: build.query({
      query: body => ({
        url: '/api/v1/core/route/stops/geojson',
        method: 'POST',
        body,
      }),
      providesTags: (result, error, body) => (body?.skipCache ? [] : [CACHE_TAG_ROUTES, CACHE_TAG_ROUTES_GEOJSON]),
    }),
    getRouteTimestamps: build.query({
      query: getRouteTimestampsQuery,
      providesTags: (result, error, body) => (body?.skipCache ? [] : [CACHE_TAG_ROUTES, CACHE_TAG_ROUTES_TIMESTAMPS]),
    }),
  }),
})

export const { useGetRouteStopsQuery, useLazyGetRouteStopsQuery, useLazyGetRouteStopsGeojsonQuery, useLazyGetRouteTimestampsQuery } =
  extendedApi

// Cache-result selector for reading loaded stops outside a component (e.g. the
// board search coordinator) — the base `api` is created with empty endpoints,
// so reach the typed endpoint through the injected api here.
export const selectGetRouteStops = extendedApi.endpoints.getRouteStops.select
